import React from 'react';
import PropTypes from 'prop-types';

export default (function (Comp) {
  return function (props) {
    var refs = {};
    var setRef = function setRef(key) {
      return function (ref) {
        refs[key] = ref;
      };
    };
    var getRef = function getRef(key) {
      return refs[key];
    };

    return React.createElement(Comp, Object.assign({ setRef: setRef, getRef: getRef }, props));
  };
});

export var refsPropType = PropTypes.object;